import { useMemo } from 'react';

import { STEP_CATALOGUE_GC_PAGE_SIZE } from 'constants/appConstants';
import {
  CONSTRAINT_COLLECTION,
  REGULAR_COLLECTIONS,
} from 'constants/gcConstants';
import {
  G_CONSTRAINT_QUERY_KEY,
  M_CONSTRAINT_QUERY_KEY,
  M_SEARCH_CONSTRAINT_QUERY_KEY,
} from 'constants/queryKeys';
import { useCatalogueDropdown } from 'hooks/useCatalogueDropdown';
import { useMOrgId } from 'hooks/useMOrgId';
import { GConstraint } from 'interfaces/IGlobalCatalogue';
import { MConstraint } from 'interfaces/IMasterDb';
import { composeList } from 'utils/catalogueMergeUtils';

import { StepSelectorOption } from './stepConfig';

const toStepSelectorOption = (item: GConstraint): StepSelectorOption => ({
  label: item.name,
  item: item.name,
  globalId: item.globalId,
});

export const useConstraintCatalogue = (gOrgId: string | null) => {
  const mOrgId = useMOrgId();

  const {
    items,
    isLoading,
    isSearchFetching,
    isPaginating: isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    hasFetchNextPageError,
    searchTerm,
    onSearch,
    clearSearch,
  } = useCatalogueDropdown<GConstraint, MConstraint, GConstraint>({
    gOrgId,
    mOrgId,
    gCollectionKey: CONSTRAINT_COLLECTION,
    mCollectionKey: 'constraint',
    gSearchCollectionName: REGULAR_COLLECTIONS.constraint,
    gQueryKey: [G_CONSTRAINT_QUERY_KEY],
    mQueryKey: [M_CONSTRAINT_QUERY_KEY],
    searchQueryKey: [M_SEARCH_CONSTRAINT_QUERY_KEY],
    mergeItems: composeList<GConstraint, MConstraint>,
    gPageSize: STEP_CATALOGUE_GC_PAGE_SIZE,
  });

  const constraintOptions = useMemo(
    () => items.map(toStepSelectorOption),
    [items]
  );

  return {
    constraintOptions,
    isLoading,
    isSearchFetching,
    hasNextPage: !!hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    hasFetchNextPageError,
    searchTerm,
    onSearch,
    clearSearch,
  };
};
